'use client';
import { createContext, useState } from 'react';
import type { AppContextProps, AppState } from './types';

export const AppContext = createContext<AppContextProps | undefined>(undefined);

const defaultState: AppState = {
  project: null,
  searchStatusId: '',
  searchProjectValue: '',
  selectedDocument: {
    documentId: '',
    name: ''
  },
  toolsForSelect: [],
  toast: {
    message: '',
    variant: 'success',
    visible: false
  },
  isLoading: false,
  appConfig: {
    appName: '',
    appVersion: '',
    privacyPolicyUrl: '',
    termsOfUseUrl: ''
  },
  documentTypeURLS: {},
  customers: [],
  releaseNotesStatus: {},
  projectContentTabIndex: 0,
  unselectedProjectMessage: '',
  isUnacceptedAccesses: false
};

export const AppProvider = ({ children }: { children: React.ReactNode }) => {
  const [state, setState] = useState<AppState>(defaultState);

  return <AppContext.Provider value={{ state, setState }}>{children}</AppContext.Provider>;
};
